import { useAuth0 } from '@auth0/auth0-react'
import { Spinner } from '@chakra-ui/react'
import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { persistTrackingParams } from '../../utils/trackingParams'

/**
 * Direct-login route: visiting /login immediately redirects to Auth0.
 * Use this URL as the "direct link to login" (e.g. https://pfs.penning.dk/login).
 * Auth0 state and redirect_uri are generated by the SDK here; linking straight
 * to the Auth0 domain would not include that state and would not work.
 */
export default function LoginRedirectScreen() {
  const history = useHistory()
  const location = useLocation()
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0()

  useEffect(() => {
    persistTrackingParams(location.search, location.pathname)
  }, [location.search, location.pathname])

  useEffect(() => {
    if (isLoading) return
    if (isAuthenticated) {
      history.replace('/app')
      return
    }
    loginWithRedirect()
  }, [isAuthenticated, isLoading, loginWithRedirect, history])

  return (
    <div className="bg-brand-light-background flex min-h-screen items-center justify-center text-fg-base">
      <div className="flex flex-col items-center gap-4">
        <Spinner size="xl" />
        <p className="text-fg-subtle">Redirecting to login…</p>
      </div>
    </div>
  )
}
